import { render } from "./Domains.vue?vue&type=template&id=0ed16fdc"
import script from "./Domains.vue?vue&type=script&lang=ts"
export * from "./Domains.vue?vue&type=script&lang=ts"
script.render = render

export default script